import React from "react";
import { Link, navigate, PageProps } from "gatsby";
import { Select } from "brass-ui-kit";

import { LEGAL_DATA } from "data/pages";
import * as styles from "./Navigation.module.scss";

const Navigation: React.FC<Partial<PageProps>> = ({ location }) => {
  return (
    <nav className={styles.Nav}>
      <div className={styles.Nav_laptop}>
        {LEGAL_DATA.LINKS.map((link, index) => (
          <Link
            key={index}
            to={link.url}
            partiallyActive
            className={styles.Nav_laptop_item}
            activeClassName={styles.Nav_laptop_item_active}
          >
            {link.name}
          </Link>
        ))}
      </div>
      <div
        style={{
          width: "100%",
        }}
      >
        <Select
          valueField="url"
          labelField="name"
          value={location?.pathname!}
          options={LEGAL_DATA.LINKS}
          className={styles.Nav_mobile}
          onChange={(item) => navigate(item.url)}
        />
      </div>
    </nav>
  );
};

export default Navigation;
